import { PurchaseOrderActions } from '../actions/purchaseOrderActions';
import { RootActions } from '../redux';
import { PurchaseOrderState, purchaseOrderState } from '../states/purchaseOrderState';

const purchaseOrderReducer = (state = purchaseOrderState, action: RootActions): PurchaseOrderState => {
  switch (action.type) {
    case PurchaseOrderActions.GET_PURCHASE_ORDER_LIST:
      return {
        ...state,
        datas: action.payload,
      };
    default:
      return state;
  }
};

export default purchaseOrderReducer;
